import React, { useState } from 'react'
import Layout from '../../../components/layouts'
import Banner from '../../../components/features/Banner'
import SEO from '../../../components/common/SEO';
import ReactWOW from 'react-wow'
import FeatureCards from "../../../components/features/FeatureCards"

export const query = graphql`
  query IncidentReporting {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl: url
        defaultImage: image
        twitterUsername
      }
    }
  }
`

export default ({ data }) => {
  const [toggler, setToggler] = useState(false)
  const lightboxProps = {
    toggler: toggler,
    setToggler: setToggler,
    sources: ["https://www.youtube.com/watch?v=xE2yXvWB038"],
  }

  const bannerProps = {
    title: 'Incident Reporting',
    subtitle: `Every organization wants to keep their team safe, but workplace incidents and near misses can occur despite our best efforts. Experience is a great teacher, and Incident reporting is essential to empower organizations to investigate, assess, and improve the safety in their worksites.`,
    featureName: 'behaviourObservations',
    rightButtonText: 'Why Certificate Tracking Software?',
    rightButtonSrc: 'https://www.youtube.com/watch?v=xE2yXvWB038',
    mockupImg: "/features/incident-reporting/feature-page-header-incidents.png"
  }

  const seo = {
    title: 'Workhub | Free EHS Incident Reporting Software / Management System',
    description: 'Our Incident Reporting Software allows you to capture, analyze and investigate data on safety incidents , near misses & dangerous conditions so that you can take corrective & preventative action.',
    image: '/features/incident-reporting/social-card.jpg',
    // pathname,
    // article
  }

  const featureIndex = [
    {
      title: "Reporting",
      para: "Log incidents in the workplace to collect statistics on the frequency and severity of incidents and near misses.",
    },
    {
      title: "Description",
      para: "Create a detailed report by uploading a description of the events, date, time, location, photos, linking assets and the environment or people involved.",
    },
    {
      title: "Injuries / Revised Work",
      para: "Reporters can log injuries to body parts on a human diagram and track an employee’s lost time and restricted work.",
    },
    {
      title: "Assign and Investigator",
      para: "Assign an investigator who can add root causes or attach additional information like witness statements, doctors’ reports, OSHA correspondence and more.",
    },
    {
      title: "Add Action Items",
      para: "Eliminate or mitigate each incident’s contributing factors by adding action items to any incident. This will ensure that corrective actions are carried out and signed off on.",
    },
    {
      title: "Charting",
      para: "Charts and graphs in the Admin panel show companywide trends in incident frequency, time lost, associated costs and more.",
    },

  ]

  return (
    <Layout {...lightboxProps}>
      <SEO {...seo} {...data.site} />
      <Banner {...bannerProps} {...lightboxProps} />

      <main className="feature-main">





        <section className="feature-section">
          <div className="container" >
            <div className="row switch-children">

              <div className="col-lg-6 feature-img">

                <ReactWOW animation="fadeInLeft" delay="0.9s">
                  <img
                    className="feature-img-right"
                    src="/features/incident-reporting/Incidents.png"
                    alt="Incident Reporting Cartoon"
                  /></ReactWOW>

              </div>


              <div className="col-lg-6 feature-text">
                <h2>What if we could predict the future?</h2>
                <p>Diligent reporting can provide meaningful statistics on the nature, frequency, and severity of incidents and near misses. Evaluating the root cause of these incidents can produce invaluable insight into how workplace practices and behaviours can be influenced through a variety of controls.</p>
              </div>
            </div>
          </div>
        </section>


        <section className="feature-section">
          <div className="container" >
            <div className="row">


              <div className="col-lg-6 feature-text">


                <h2>Incident reporting starts with the basics</h2>

                <p>Every incident or near miss report starts with essential information, including the date, time, location, and description of the event. Reporters can also include important details for people, assets, and environments affected. Reports can collects data for every individual, including their name, involvement with your organization (or lack thereof), injuries, any lost time, and work restrictions. Photographs and supporting documentation can be uploaded to add crucial evidence to each report.</p>

              </div>

              <div className="col-lg-6 feature-img">

                <ReactWOW animation="fadeInRight" delay="0.9s">

                  <img
                    className="feature-img-left"
                    src="/features/incident-reporting/sketch-mockup-incidents-worker-1.png"
                    alt="Tablet View"
                  />

                </ReactWOW>

              </div>

            </div>
          </div>
        </section>



        <section className="feature-section">
          <div className="container" >
            <div className="row switch-children">

              <div className="col-lg-6 feature-img">

                <ReactWOW animation="fadeInLeft" delay="0.9s">

                  <img
                    className="feature-img-right"
                    src="/features/incident-reporting/sketch-mockup-incidents-admin-2.png"
                    alt="Admin Computer"
                  />

                </ReactWOW>

              </div>


              <div className="col-lg-6 feature-text">

                <h2>Getting to the root of the matter</h2>

                <p>Once a report has been submitted, administrators can assign an investigator to the case. Investigators can review report contents, add supplementary documentation like investigation reports or worker injury reports, and can identify root causes. Root cause analysis is essential to proactive management of workplace risks and helps make your workplace safer for you, your team, and the public. </p>

              </div>
            </div>
          </div>
        </section>



        <section className="feature-section">
          <div className="container">
            <div className="row">

              <div className="col-lg-6 feature-text">

                <h2>Process of elimination</h2>

                <p>Eliminate or mitigate each incident’s contributing factors by adding action items to any incident. This will ensure corrective actions are carried out (and signed off) for any and all deficiencies. A safer workplace and better safety culture will be the reward.</p>

                <p>Once causes have been identified, you can eliminate or mitigate the contributing factors by creating action items. Action items outline deficiencies in your safety program and prescribe corrective actions, assignable to any member of your team. After they complete the task(s), those action items can be closed and signed off on by a trusted authority in your organization. </p>

                <p>Each step, no matter how small, contributes to a safer workplace and better safety culture!</p>
                
              </div>

              <div className="col-lg-6 feature-img">

                <ReactWOW animation="fadeInLeft" delay="0.9s">

                  <img
                    className="feature-img-left"
                    src="/features/incident-reporting/sketch-mockup-incidents-worker-3.png"
                    alt="Worker Mobile"
                  />

                </ReactWOW>

              </div>


            </div>
          </div>
        </section>

        {/* FEATURE OVERVIEW */}

        <section className="feature-overview-container">
          <h2>Overview</h2>

          <div className="feature-overview-grid">
            {featureIndex.map(item => (
              <FeatureCards title={item.title} para={item.para} />
            ))}
          </div>
        </section>

      </main>

    </Layout>
  )
}